'use es6';

import TaskRecord from 'customer-data-objects/task/TaskRecord';
import PropTypes from 'prop-types';
const TaskType = PropTypes.instanceOf(TaskRecord);
export default TaskType;